import React from "react";
import { FieldRenderProps } from "react-final-form";

import { FormLabel } from "@material-ui/core";

import DropZone, { ExternalDropZoneProps } from "components/DropZone";

import withFieldControl from "../FieldControl";

import { Container } from "./styles";

type Props = {
  title: string;
  invalidFileTypeMessage?: string;
} & FieldRenderProps<any> &
  ExternalDropZoneProps;

class UploadFieldControl extends React.Component<Props> {
  addedfile = (file: File) => {
    const { input } = this.props;
    const event: any = {
      target: { value: file },
    };
    input.onChange(event);
  };

  removedFile = () => {
    const { input } = this.props;
    const event: any = {
      target: { value: undefined },
    };
    input.onChange(event);
  };

  render() {
    const { title, meta, ...props } = this.props;

    return (
      <Container>
        {title && <FormLabel>{title}</FormLabel>}
        <DropZone
          componentConfig={{ postUrl: "no-url" }}
          eventHandlers={{
            addedfile: this.addedfile,
            removedfile: this.removedFile,
          }}
          error={(meta.touched || meta.dirty) && meta.error}
          autoUpload={false}
          maxFiles={1}
          hideProgressBar
          addRemoveLinks
          fitWidth
          {...props}
        />
      </Container>
    );
  }
}

export default withFieldControl(UploadFieldControl);
